import React, { useEffect } from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { CTASection } from '../components/CTASection';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Check } from 'lucide-react';
export function ClassesPage() {
  useEffect(() => {
    document.title = "Classes | Walker's Martial Arts | Bloomington, Illinois";
  }, []);
  const classes = [{
    name: 'TAEKWONDO',
    link: '/classes/taekwondo',
    image: 'https://images.squarespace-cdn.com/content/v1/6782c238cf9313348308674a/1736784232481-R4XWW960TB4VCKUGAOL8/TRANSPARENT+LEADERSHIP.png',
    description: 'Traditional Korean martial art emphasizing kicks, discipline, and respect. Classes for all ages from Little Tigers (3-5) to Adults.',
    features: ['Ages 3 to Adult', 'Traditional Forms & Techniques', 'Belt Progression System', 'Character Development']
  }, {
    name: 'KICKBOXING',
    link: '/classes/kickboxing',
    image: 'https://images.squarespace-cdn.com/content/v1/6782c238cf9313348308674a/1736784617025-Z0BI14DKFMDG7TSB8AQ1/gabriel+alilah+belt+champions+2.png',
    description: 'High-intensity cardio workout combining martial arts techniques with fitness training. Perfect for getting in shape while learning self-defense.',
    features: ['Kids (6-11) & Adults (12+)', 'High-Energy Cardio', 'Strength & Conditioning', 'Practical Striking Techniques']
  }, {
    name: 'GROUP & CORPORATE SELF DEFENSE SEMINARS',
    link: '/classes/self-defense-seminars',
    image: 'https://images.squarespace-cdn.com/content/v1/6782c238cf9313348308674a/1736957703336-TKRC2PNOIT6O3HJH366K/self+defense+blank.png',
    description: 'Specialized self-defense training for individuals, groups, schools, and corporate teams. Learn practical skills in a focused environment.',
    features: ['Individual Sessions', 'Group Workshops', 'Corporate Training', 'Customizable Programs']
  }, {
    name: 'PRIVATE CLASSES',
    link: '/classes/private-classes',
    image: 'https://images.unsplash.com/photo-1599058945522-28d584b6f0ff?q=80&w=2069&auto=format&fit=crop',
    description: 'One-on-one instruction tailored to your specific goals and schedule. Accelerate your progress with personalized attention from expert instructors.',
    features: ['All Ages & Skill Levels', 'Personalized Curriculum', 'Flexible Scheduling', 'Accelerated Progress']
  }];
  return <div className="bg-black min-h-screen" data-id="element-400">
      <Navigation data-id="element-401" />

      {/* Page Header */}
      <div className="pt-32 pb-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-402">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-403">
          <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-6" data-id="element-404">
            Our <span className="text-[#00D4FF]" data-id="element-405">Classes</span>
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl leading-relaxed" data-id="element-406">
            Choose from our comprehensive martial arts programs designed for all
            ages and skill levels.
          </p>
        </motion.div>
      </div>

      {/* Classes Grid */}
      <section className="py-12 bg-[#0a0a0a]" data-id="element-407">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-408">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-409">
            {classes.map((classItem, index) => <motion.div key={classItem.name} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1,
            duration: 0.5
          }} className="relative rounded-2xl overflow-hidden group border border-gray-800" data-id="element-410">
                <Link to={classItem.link} className="block" data-id="element-411">
                  <div className="h-64 overflow-hidden relative" data-id="element-412">
                    <div className="absolute inset-0 bg-black/40 group-hover:bg-black/20 transition-colors z-10" data-id="element-413" />
                    <img src={classItem.image} alt={classItem.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" data-id="element-414" />
                    <div className="absolute bottom-4 left-4 z-20" data-id="element-415">
                      <h3 className="text-2xl font-bold text-white uppercase tracking-wide" data-id="element-416">
                        {classItem.name}
                      </h3>
                    </div>
                  </div>
                </Link>

                <div className="p-8 bg-[#1a1a1a]" data-id="element-417">
                  <p className="text-gray-400 mb-6 leading-relaxed" data-id="element-418">
                    {classItem.description}
                  </p>

                  <ul className="space-y-3 mb-8" data-id="element-419">
                    {classItem.features.map(feature => <li key={feature} className="flex items-start gap-3 text-sm text-gray-300" data-id="element-420">
                        <Check className="w-5 h-5 text-[#00D4FF] shrink-0" data-id="element-421" />
                        {feature}
                      </li>)}
                  </ul>

                  <Link to={classItem.link} className="w-full py-3 rounded border border-gray-600 text-white font-bold uppercase tracking-wider hover:bg-white hover:text-black transition-colors block text-center" data-id="element-422">
                    Learn More
                  </Link>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      <CTASection data-id="element-423" />
      <Footer data-id="element-424" />
    </div>;
}